(() => {
  const toggles = Array.from(document.querySelectorAll('[data-nav-toggle]'));

  function panelFor(toggle) {
    const id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function close(toggle, returnFocus = false) {
    const panel = panelFor(toggle);
    toggle.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (returnFocus) toggle.focus();
  }

  function closeAll(except) {
    toggles.forEach((toggle) => {
      if (toggle !== except) close(toggle);
    });
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const panel = panelFor(toggle);
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(toggle);
      toggle.setAttribute('aria-expanded', String(willOpen));
      if (panel) panel.hidden = !willOpen;
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-site-header]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openToggle = toggles.find((toggle) => toggle.getAttribute('aria-expanded') === 'true');
    if (openToggle) {
      closeAll();
      openToggle.focus();
    }
  });

  window.matchMedia('(min-width: 901px)').addEventListener('change', () => closeAll());

  function setupProductGallery(gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const position = gallery.querySelector('[data-gallery-position]');
    if (!track || !slides.length || !position) return;

    const mobileQuery = window.matchMedia('(max-width: 900px)');
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);

    function offsetFor(index) {
      const trackRect = typeof track.getBoundingClientRect === 'function' ? track.getBoundingClientRect() : null;
      const slideRect = typeof slides[index].getBoundingClientRect === 'function' ? slides[index].getBoundingClientRect() : null;
      if (trackRect && slideRect) return track.scrollLeft + slideRect.left - trackRect.left;
      return slides[index].offsetLeft - track.offsetLeft;
    }

    function align(index, behavior) {
      const left = offsetFor(index);
      if (typeof track.scrollTo === 'function') track.scrollTo({ left, behavior });
      else track.scrollLeft = left;
    }

    function activate(index, alignTrack = false, behavior = 'auto') {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });
      position.textContent = `${activeIndex + 1} / ${slides.length}`;
      if (alignTrack) align(activeIndex, behavior);
    }

    const productMain = typeof gallery.closest === 'function' ? gallery.closest('.product-main') : null;
    const fabricInputs = productMain
      ? Array.from(productMain.querySelectorAll('[data-fabric-code][data-gallery-image], [data-universal-option-value][data-gallery-image]'))
      : [];
    const primaryImage = slides[0]?.querySelector?.('[data-gallery-primary-image]') || slides[0]?.querySelector?.('img');
    const primaryThumbnailImage = thumbnails[0]?.querySelector?.('[data-gallery-primary-thumbnail]') || thumbnails[0]?.querySelector?.('img');
    let selectedFabricCode = fabricInputs.find((input) => input.checked)?.value || '';

    function showFabricPreview(input) {
      if (!input.checked || !primaryImage || !input.dataset.galleryImage) return;

      primaryImage.src = input.dataset.galleryImage;
      primaryImage.alt = input.dataset.galleryAlt || input.dataset.colorName || '';
      if (primaryThumbnailImage) primaryThumbnailImage.src = input.dataset.galleryImage;
      slides[0].classList.add('product-media--fabric');

      activate(0, true, 'auto');
      slides[0].scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'start'
      });
    }

    fabricInputs.forEach((input) => {
      input.addEventListener('change', () => {
        selectedFabricCode = input.value;
        showFabricPreview(input);
      });

      input.addEventListener('click', () => {
        if (input.checked && input.value === selectedFabricCode) showFabricPreview(input);
      });
    });

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        activate(index, true, reduceMotion ? 'auto' : 'smooth');
        slides[index].scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      });
    });

    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = slides.reduce((nearest, slide, slideIndex) => (
          Math.abs(offsetFor(slideIndex) - track.scrollLeft) < Math.abs(offsetFor(nearest) - track.scrollLeft)
            ? slideIndex
            : nearest
        ), 0);
        activate(index);
      });
    }, { passive: true });

    mobileQuery.addEventListener('change', (event) => {
      activate(activeIndex);
      if (event.matches) requestAnimationFrame(() => align(activeIndex, 'auto'));
    });

    activate(activeIndex);
    gallery.classList.add('is-enhanced');
  }

  document.querySelectorAll('[data-product-gallery]').forEach(setupProductGallery);
})();
